<style lang="scss" scoped>
.text-h-50 {
  min-height: 50px;
}
.mobile-details {
  &:not(.has-trial) {
    height: calc(100vh - 50px);
    height: calc(var(--vh, 1vh) * 100 - 50px);
  }
  &.has-trial {
    height: calc(100vh - 24px - 50px);
    height: calc(var(--vh, 1vh) * 100 - 24px - 50px);
  }
}
.pie-chart {
  width: 32px;
  height: 32px;
  background-color: #f2f2f2;
  border-radius: 50%;
  margin: auto 16px auto auto;
  position: relative;
  display: flex;
  &:before {
    content: '';
    width: 3px;
    height: 100%;
    background: #fff;
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
  }
}
.new-meds {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0 12px;
  width: 50%;
  &:focus {
    outline: none;
  }
}

::v-deep .medication-input input {
  margin-top: 0 !important;
  border: 1px solid #ced4da;
  &:focus {
    outline: none;
  }
}

.warning {
  position: absolute;
  left: 15px;
  bottom: 20px;
  width: 15px;
  height: 15px;
  background: var(--danger);
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 15px;
  font-size: 11px;
}
.medication-select {
  @media only screen and (max-width: 576px) {
    max-width: 70px;
  }
}
::v-deep .time-picker {
  display: flex;
  flex-direction: column-reverse;
}
.form-footer {
  @media screen and (min-width: 1025px) {
    width: calc(100% - 300px);
  }
}
.locked {
  filter: blur(3px);
  pointer-events: none;
  user-select: none;
}
.locked-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 1;
  &.overlay-background {
    background: var(--white);
    opacity: 0.6;
  }
}
</style>
<style lang="scss">
.v--modal-box {
  @media only screen and (max-width: 600px) {
    width: auto !important;
    top: 0 !important;
    left: 0 !important;
  }
}
</style>


<template>
    <div v-if="scheduleOverview">
        <div v-if="!this.update && locked" class="locked-overlay overlay-background">

        </div>
        <div v-if="!this.update && locked" class="locked-overlay d-flex justify-content-center align-items-center flex-column px-16">
            <i-lock class="i-42 mb-16 mx-auto"></i-lock>
            <span class="text-center fw-b">{{$t('pages.schedule.schedule_unavailable')}}</span>
            <span class="mb-32 text-center" v-if="$moment(data.date) > $moment()">{{$t('pages.schedule.schedule_available_on', {date: $moment(data.date).format('dddd DD MMMM YYYY')})}}</span>
            <span class="mb-32 text-center" v-else>{{$t('pages.schedule.schedule_ensure_correct')}}</span>
            <router-link class="btn btn-primary" v-if="$moment(data.date) > $moment()" :to="{ name: 'sleep-schedule' }">{{$t('pages.schedule.to_schedule')}}</router-link>
            <router-link class="btn btn-primary" v-else-if="previousUnlockedWeek && previousUnlockedEntry" :to="{ name: 'schedule-details', query: { date: previousUnlockedEntry.date, week: previousUnlockedWeek.week} }">{{$t('pages.schedule.to_previous_entry')}}</router-link>
        </div>
        <div class="container px-0 px-md-16" :class="{'locked' : !this.update && locked}">
            <modal name="add-medication" :pivotY="$root.sizer === 'lg' ? 0.5 : 0" :adaptive="$root.sizer === 'lg' ? false : true" :width="$root.sizer === 'lg' ? 650 : '100%'" :minHeight="600" :height="$root.sizer === 'lg' ? 'auto' : '100%'" :scrollable="true">
                <div class="p-16 p-lg-44" style="overflow: auto; max-height: 95vh;">
                    <h4 class="fw-b text-primary-dark mb-24">{{ $t('pages.schedule.add_medication_title') }}</h4>

                    <div>
                        <div v-for="(meds, index) in local_medications" :key="meds.id" class="border-bottom border-gray-light d-flex flex-row mb-16 pb-16 align-items-end">
                            <el-input :ref="`medication_name_input_${index}`" :forced-error="errors.first(`medication.medication_name_${index}`)" v-validate="'required'" data-vv-scope="medication" :data-vv-name="`medication_name_${index}`" :data-vv-as="$t('pages.schedule.medication_name')" class="mr-16 mb-0 medication-input align-self-end" v-model="meds.label" type="text" :placeholder="$t('pages.schedule.add_other_medication_placeholder')" />
                            <span class="pie-chart" :style="{ 'background-image': `conic-gradient(var(--primary) ${getConicPercentage(meds.amount)}%, #f2f2f2 ${getConicPercentage(meds.amount)}% )`, 'margin-bottom': '17px' }"></span>
                            <el-select :ref="`medication_dose_input_${index}`" :forced-error="errors.first(`medication.medication_dose_${index}`)" v-validate="'required'" data-vv-scope="medication" :data-vv-name="`medication_dose_${index}`" :data-vv-as="$t('pages.schedule.dose')" class="mb-0 medication-select align-self-end" v-model="meds.amount" :hasLabel="false" :options="['>1',  '1', '3/4', '1/2',  '1/4', '1/8', '1/16']" name="meds_amount_value"></el-select>
                            <i-cross class="i-20 ml-16 fill-gray fill-dark-hover c-pointer" @click="local_medications.splice(index,1)" :style="{ 'margin-bottom': '18px' }" />
                        </div>
                        <a class="d-flex flex-row mb-16 py-16 text-gray c-pointer" href="#" @click.prevent="local_medications.push({ label: '', can_edit: true, value: '' })">
                            {{ $t('pages.schedule.add_other_medication') }}
                        </a>
                        <div class="d-flex mt-150">
                            <a href="#" class="btn btn-primary ml-auto" @click="submitMedication">{{ $t('general.save') }}</a>
                        </div>
                    </div>
                </div>
            </modal>

            <template v-if="$root.sizer === 'lg'">

                <div class="form-content px-xl-48 pt-32">

                    <div class="mb-32 row">
                        <div class="col-12 d-flex align-items-center">
                            <router-link :to="{ name: 'sleep-schedule' }">
                                <i-back class="i-14 my-auto mr-16 fill-gold"></i-back>
                            </router-link>
                            <h4 class="fw-b mb-0">{{ [data.date, 'YYYY-MM-DD'] | moment('dddd DD MMMM YYYY') }}</h4>
                        </div>
                    </div>

                    <div class="row mb-32">
                        <div class="col-12">
                            <p class="fw-b">{{ $t('pages.schedule.fill_in_schedule') }}</p>
                            <p class="text-primary-dark small mb-32">{{ $t('pages.schedule.fill_in_schedule_info') }}</p>
                            <el-error :error="server_error"></el-error>
                        </div>
                    </div>

                    <div class="row mb-60">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-3 d-flex flex-wrap flex-column justify-content-between">
                                    <i-to-bed class="i-50 mx-auto mb-16"></i-to-bed>
                                    <p class="w-100 text-center text-h-50 mb-24">{{ $t('pages.schedule.time_to_bed') }}</p>
                                </div>
                                <div class="col-3 d-flex flex-wrap flex-column justify-content-between">
                                    <i-to-sleep class="i-50 mx-auto mb-16"></i-to-sleep>
                                    <p class="w-100 text-center text-h-50 mb-24">{{ $t('pages.schedule.time_in_sleep') }}</p>
                                </div>
                                <div class="col-3 d-flex flex-wrap flex-column justify-content-between">
                                    <i-wakeup class="i-50 mx-auto mb-16"></i-wakeup>
                                    <p class="w-100 text-center text-h-50 mb-24">{{ $t('pages.schedule.time_wake_up') }}</p>
                                </div>
                                <div class="col-3 d-flex flex-wrap flex-column justify-content-between">
                                    <i-get-out class="i-50 mx-auto mb-16"></i-get-out>
                                    <p class="w-100 text-center text-h-50 mb-24">{{ $t('pages.schedule.time_out_bed') }}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <el-error v-if="!validSleep || !validAwake" class="mb-32 ml-32 fw-b" :error="$t('pages.schedule.incorrect_dates')" :translate="false"></el-error>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 d-flex flex-wrap flex-column justify-content-end">
                                    <span class="warning" v-if="!validSleep || errors.has($t('form-elements.to_bed_at'))">!</span>
                                    <span class="text-danger small mb-4 ml-32 fw-b" v-if="errors.has($t('form-elements.to_bed_at'))">{{ $t('form-elements.fill-in-valid-time') }}</span>
                                    <div class="px-32">
                                        <el-timepicker v-model="data_in_bed" @change="recompute++; data.in_bed =  (data_in_bed.HH && data_in_bed.mm) ? `${data_in_bed.HH}:${data_in_bed.mm}` : null" :bottom="true" :minute-interval="30" :hide-clear-button="true" :placeholder="$t('form-elements.to_bed_at_placeholder')" v-validate="'time_required'" :data-vv-name="$t('form-elements.to_bed_at')" :has-error="false"></el-timepicker>
                                    </div>
                                </div>
                                <div class="col-3 d-flex flex-wrap flex-column justify-content-end">
                                    <span class="warning" v-if="!validSleep || errors.has($t('pages.schedule.time_in_sleep'))">!</span>
                                    <span class="text-danger small mb-4 ml-32 fw-b" v-if="errors.has($t('pages.schedule.time_in_sleep'))">{{ $t('form-elements.fill-in-valid-time') }}</span>
                                    <div class="px-32">
                                        <el-timepicker v-model="data_asleep" @change="recompute++; data.asleep = (data_asleep.HH && data_asleep.mm) ? `${data_asleep.HH}:${data_asleep.mm}` : null" :bottom="true" :minute-interval="30" :hide-clear-button="true" :placeholder="$t('form-elements.in_sleep_at_placeholder')" v-validate="'time_required'" :data-vv-name="$t('pages.schedule.time_in_sleep')" :has-error="false"></el-timepicker>
                                    </div>
                                </div>
                                <div class="col-3 d-flex flex-wrap flex-column justify-content-end">
                                    <span class="warning" v-if="!validAwake || errors.has($t('pages.schedule.time_wake_up'))">!</span>
                                    <span class="text-danger small mb-4 ml-32 fw-b" v-if="errors.has($t('pages.schedule.time_wake_up'))">{{ $t('form-elements.fill-in-valid-time') }}</span>
                                    <div class="px-32">
                                        <el-timepicker v-model="data_awaken" @change="recompute++; data.awaken = (data_awaken.HH && data_awaken.mm) ? `${data_awaken.HH}:${data_awaken.mm}` : null" :top="true" :minute-interval="30" :hide-clear-button="true" :placeholder="$t('form-elements.wakeup_at_placeholder')" v-validate="'time_required'" :data-vv-name="$t('pages.schedule.time_wake_up')" :has-error="false"></el-timepicker>
                                    </div>
                                </div>
                                <div class="col-3 d-flex flex-wrap flex-column justify-content-end">
                                    <span class="warning" v-if="!validAwake || errors.has($t('pages.schedule.time_out_bed'))">!</span>
                                    <span class="text-danger small mb-4 ml-32 fw-b" v-if="errors.has($t('pages.schedule.time_out_bed'))">{{ $t('form-elements.fill-in-valid-time') }}</span>
                                    <div class="px-32">
                                        <el-timepicker v-model="data_out_bed" @change="recompute++; data.out_bed = (data_out_bed.HH && data_out_bed.mm) ? `${data_out_bed.HH}:${data_out_bed.mm}` : null" :top="true" :minute-interval="30" :hide-clear-button="true" :placeholder="$t('form-elements.out_bed_at_placeholder')" v-validate="'time_required'" :data-vv-name="$t('pages.schedule.time_out_bed')" :has-error="false"></el-timepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-60">
                        <div class="col-12">
                            <p class="fw-b">{{ $t('pages.schedule.did_you_wakeup_inbetween') }}</p>
                            <p class="text-primary-dark small mb-32">{{ $t('pages.schedule.did_you_wakeup_inbetween_info') }}</p>
                            <el-wakeup v-if="validSleep && validAwake" v-model="data.sleep_disturbances" :date="data.date" :inBed="data.in_bed" :asleep="data.asleep" :awake="data.awaken" :outBed="data.out_bed"></el-wakeup>
                        </div>
                    </div>

                    <div class="row mb-60">
                        <div class="col-12">
                            <p class="fw-b">{{ $t('pages.schedule.did_you_nap') }}</p>
                            <el-wakeup v-if="validSleep && validAwake" v-model="data.naps" :date="previous_out_bed.date" :inBed="previous_out_bed.time" :asleep="previous_out_bed.time" :awake="data.in_bed" :outBed="data.in_bed" wakeup-color="var(--success)" wakeup-color-hover="green">
                                <template v-slot:to-sleep-icon>
                                    <i-wakeup class="i-20 icon"></i-wakeup>
                                </template>
                                <template v-slot:wakeup-icon>
                                    <i-to-sleep class="i-20 icon"></i-to-sleep>
                                </template>
                            </el-wakeup>
                        </div>
                    </div>

                    <div class="row mb-60">
                        <div class="col-6">
                            <p class=" fw-b mb-8"> {{ $t('pages.schedule.did_you_take_medicine') }} </p>
                            <div v-if="medications.filter((med) => med.amount).length === 0" class="form-row">
                                <el-toggle v-model="did_you_take_mediations" @input="() => { if(did_you_take_mediations) $modal.show('add-medication'); }" :hasLabel="false" class="col-12"></el-toggle>
                            </div>
                            <div v-else>
                                {{ $t('pages.schedule.yes_i_took', { meds: medications.filter((med) => med.amount).map((med) => med.label ).join(', ') }) }}
                                <a href="#" @click="$modal.show('add-medication')">{{ $t('general.change') }}</a>
                            </div>
                        </div>
                        <div class="col-6">
                            <p class="fw-b mb-8"> {{ $t('pages.schedule.how_did_you_sleep') }}</p>
                            <el-select v-model="sleep_type" @input="data.sleep_type_id = sleep_type.id" :hasLabel="false" :options="sleepTypes" labelKey="name" valueKey="id" :translate="true" name="sleep_type_id" :placeholder="$t('pages.schedule.how_did_you_sleep')"></el-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-8">
                            <el-input v-model="data.note" type="textarea" rule="max:150" name="note" :as="$t('pages.schedule.extra_note')" :placeholder="$t('form-elements.extra_note_placeholder')">
                                <template slot="label-cta">
                                    <div>
                                        <p class="h6 fw-b mb-0">{{ $t('pages.schedule.extra_note') }}</p>
                                        <p class="text-primary-dark mb-0">{{ $t('pages.schedule.extra_note_info') }}</p>
                                    </div>
                                    <span class="ml-auto"> {{ data.note.length }} / 150</span>
                                </template>
                            </el-input>
                        </div>
                    </div>
                </div>

                <div class="form-footer px-lg-60 position-fixed">
                    <div class="row">
                        <div class="col-auto ml-auto">
                            <button class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" @click="submit" v-bind:class="{ disabled : loading }">
                                <template v-if="update || current_week > 6">
                                    {{ $t('general.save') }}
                                </template>
                                <template v-else>
                                    {{ $t('pages.schedule.continue_to_tip')}}
                                </template>
                                <template v-if="loading">
                                    <i-loader class="ml-2 i-20 my-auto"></i-loader>
                                </template>
                                <template v-if="success">
                                    <i-check class="ml-2 i-20 my-auto"></i-check>
                                </template>
                            </button>
                        </div>
                    </div>
                </div>

            </template>

            <div v-else-if="$root.sizer === 'sm' || $root.sizer === 'md'" class="mobile-details py-16 py-md-32" :class="{ 'has-trial' : currentUser.user.trial }">
                <div class="row">
                    <div class="col-12 text-left mb-16 mb-md-32">
                        <h4 class="fw-b mb-0">{{ [data.date, 'YYYY-MM-DD'] | moment('dddd DD MMMM YYYY') }}</h4>
                    </div>

                    <div v-if="mobile_step === 1" class="col-12 d-flex flex-column align-content-start">
                        <form class="row" data-vv-scope="in_bed">
                            <div class="col-6 d-flex flex-wrap flex-column">
                                <i-to-bed class="i-42 mx-auto mb-16"></i-to-bed>
                                <p class="w-100 text-center mb-24 small">{{ $t('pages.schedule.time_to_bed') }}</p>
                                <el-timepicker class="datepicker" v-model="data_in_bed" @change="data.in_bed =  (data_in_bed.HH && data_in_bed.mm) ? `${data_in_bed.HH}:${data_in_bed.mm}` : null" :bottom="true" :minute-interval="30" :hide-clear-button="true" :placeholder="$t('form-elements.to_bed_at_placeholder')" key="in_bed_1" :data-vv-name="$t('pages.schedule.time_to_bed')" v-validate="'time_required|valid_sleep'" data-vv-scope="in_bed" data-vv-validate-on="none"></el-timepicker>
                            </div>
                            <div class="col-6 d-flex flex-wrap flex-column">
                                <i-to-sleep class="i-42 mx-auto mb-16"></i-to-sleep>
                                <p class="w-100 text-center mb-24 small">{{ $t('pages.schedule.time_in_sleep') }}</p>
                                <el-timepicker class="datepicker" v-model="data_asleep" @change="data.asleep = (data_asleep.HH && data_asleep.mm) ? `${data_asleep.HH}:${data_asleep.mm}` : null" :bottom="true" :minute-interval="30" :hide-clear-button="true" :placeholder="$t('form-elements.in_sleep_at_placeholder')" key="in_bed_2" :data-vv-name="$t('pages.schedule.time_in_sleep')" :name="$t('pages.schedule.time_to_bed')" v-validate="'time_required|valid_sleep'" data-vv-scope="in_bed" data-vv-validate-on="none"></el-timepicker>
                            </div>
                        </form>
                    </div>

                    <div v-if="mobile_step === 2" class=" col-12 d-flex flex-column align-content-start">
                        <form class="row" data-vv-scope="out_bed">
                            <div class="col-6 d-flex flex-wrap flex-column">
                                <i-wakeup class="i-42 mx-auto mb-16"></i-wakeup>
                                <p class="w-100 text-center text-h-50 mb-24 small">{{ $t('pages.schedule.time_wake_up') }}</p>
                                <el-timepicker class="datepicker" v-model="data_awaken" @change="data.awaken = (data_awaken.HH && data_awaken.mm) ? `${data_awaken.HH}:${data_awaken.mm}` : null" :top="true" :minute-interval="30" :hide-clear-button="true" :placeholder="$t('form-elements.wakeup_at_placeholder')" key="out_bed_1" :data-vv-name="$t('pages.schedule.time_wake_up')" v-validate="'time_required|valid_awake'" data-vv-scope="out_bed" data-vv-validate-on="none"></el-timepicker>
                            </div>
                            <div class="col-6 d-flex flex-wrap flex-column">
                                <i-get-out class="i-42 mx-auto mb-16"></i-get-out>
                                <p class="w-100 text-center text-h-50 mb-24 small">{{ $t('pages.schedule.time_out_bed') }}</p>
                                <el-timepicker class="datepicker" v-model="data_out_bed" @change="data.out_bed = (data_out_bed.HH && data_out_bed.mm) ? `${data_out_bed.HH}:${data_out_bed.mm}` : null" :top="true" :minute-interval="30" :hide-clear-button="true" :placeholder="$t('form-elements.out_bed_at_placeholder')" key="out_bed_2" :data-vv-name="$t('pages.schedule.time_out_bed')" v-validate="'time_required|valid_awake'" data-vv-scope="out_bed" data-vv-validate-on="none"></el-timepicker>
                            </div>
                        </form>
                    </div>

                    <div v-if="mobile_step === 3" class="col-12 d-flex flex-wrap align-content-start">
                        <el-wakeup v-if="validSleep && validAwake" ref="mobileWakeup" class="mb-auto" v-model="data.sleep_disturbances" :date="data.date" :mobile="true" :inBed="data.in_bed" :asleep="data.asleep" :awake="data.awaken" :outBed="data.out_bed" @input="validateMobileWakeup()" @timesChanged="value => mobile_has_wakup_times_changed = value"></el-wakeup>
                        <div v-if="mobile_has_wakup_errors" class="col-11 mt-16 px-0">
                            <span class="label-error small fw-b">{{ $t('errors.invalid_sleep_disturbances') }}</span>
                        </div>
                        <div v-if="mobile_has_wakup_times_changed" class="col-11 mt-16 px-0">
                            <span class="label-error small fw-b">{{ $t('warnings.times_changed') }}</span>
                        </div>
                    </div>

                    <div v-if="mobile_step === 4" class=" col-12 d-flex flex-column align-content-start">
                        <el-wakeup v-if="validSleep && validAwake" ref="mobileWakeup" class="mb-auto" v-model="data.naps" :date="previous_out_bed.date" :mobile="true" :inBed="previous_out_bed.time" :asleep="previous_out_bed.time" :awake="data.in_bed" :outBed="data.in_bed" @input="validateMobileWakeup()" @timesChanged="value => mobile_has_wakup_times_changed = value">
                            <template v-slot:mobile-label>
                                {{ $t('pages.schedule.did_you_nap') }}
                            </template>
                        </el-wakeup>
                        <div v-if="mobile_has_wakup_errors" class="col-11 mt-16 px-0">
                            <span class="label-error small fw-b">{{ $t('errors.invalid_sleep_disturbances') }}</span>
                        </div>
                        <div v-if="mobile_has_wakup_times_changed" class="col-11 mt-16 px-0">
                            <span class="label-error small fw-b">{{ $t('warnings.times_changed') }}</span>
                        </div>
                    </div>

                    <div v-if="mobile_step === 5" class="col-12 d-flex flex-wrap align-content-start">
                        <p class="h6 fw-b mb-0 w-100">{{ $t('pages.schedule.extra_note') }}</p>
                        <p class="text-primary-dark mb-0 w-100">{{ $t('pages.schedule.extra_note_info') }}</p>
                        <el-input v-model="data.note" data-vv-scope="mobile_step_5" class="w-100" type="textarea" v-validate="'max:150'" rule="max:150" name="note" :as="$t('pages.schedule.extra_note')" :placeholder="$t('form-elements.extra_note_placeholder')">
                            <template slot="label-cta">
                                <span class="ml-auto"> {{ data.note.length }} / 150</span>
                            </template>
                        </el-input>
                    </div>

                    <div v-if="mobile_step === 6" class="col-12">
                        <p class="fw-b mb-8"> {{ $t('pages.schedule.did_you_take_medicine') }} </p>
                        <div class="form-row">
                            <el-toggle v-model="did_you_take_mediations" @input="handleDidYouTakeMedicationChange" :hasLabel="false" class="col-12"></el-toggle>
                        </div>

                        <div v-show="did_you_take_mediations">
                            <div v-for="(meds, index) in medications" :key="meds.id" class="border-bottom border-gray-light d-flex flex-row mb-16 pb-16">
                                <input class="new-meds mr-16" v-model="meds.label" @input="validateMobileMedication()" type="text" :placeholder="$t('pages.schedule.add_other_medication_placeholder')">
                                <span class="pie-chart flex-none" :style="{ 'background-image': `conic-gradient(var(--primary) ${getConicPercentage(meds.amount)}%, #f2f2f2 ${getConicPercentage(meds.amount)}% )` }"></span>
                                <el-select class="mb-0 medication-select flex-none" v-model="meds.amount" @input="validateMobileMedication()" :hasLabel="false" :options="['>1',  '1', '3/4', '1/2',  '1/4', '1/8', '1/16']" name="meds_amount_value"></el-select>
                                <i-cross class="i-20 my-auto ml-16 fill-gray fill-dark-hover c-pointer" @click="medications.splice(index,1)" />
                            </div>
                            <a class="d-flex flex-row mb-16 py-16 text-gray c-pointer" href="#" @click="medications.push({ label: '', can_edit: true, value: '' })">
                                {{ $t('pages.schedule.add_other_medication') }}
                            </a>
                        </div>

                        <div v-if="mobile_has_medication_errors" class="col-11 mt-16 px-0">
                            <span class="label-error small fw-b">{{ $t('errors.invalid_medication_info') }}</span>
                        </div>

                    </div>

                    <div class="col-12 d-flex flex-row mb-60 mt-16">
                        <a v-if="mobile_step !== 1" class="text-primary-dark my-auto mr-16" href="#" @click="mobile_step--">{{ $t('general.previous') }}</a>
                        <button v-if="mobile_step !== 6" class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" @click="next">{{ $t('general.next') }}</button>
                        <button v-else class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" @click="submit" v-bind:class="{ disabled : loading }">
                            <template v-if="update || current_week > 6">
                                {{ $t('general.save') }}
                            </template>
                            <template v-else>
                                {{ $t('pages.schedule.continue_to_tip')}}
                            </template>
                            <template v-if="loading">
                                <i-loader class="ml-2 i-20 my-auto"></i-loader>
                            </template>
                            <template v-if="success">
                                <i-check class="ml-2 i-20 my-auto"></i-check>
                            </template>
                        </button>
                    </div>
                </div>
            </div>

            <div v-else>
                Het Schema kan niet worden getoond op dit toestel
            </div>
        </div>
    </div>
</template>

<script>
import { ElInput, ElSelect, ElToggle, ElWakeup, ElTimepicker, ElError } from '@/components/forms'

export default {
    components: { ElInput, ElSelect, ElToggle, ElWakeup, ElTimepicker, ElError },

    data: vm => ({
        loading: false,
        success: false,
        server_error: null,
        update: true,
        mobile_has_wakup_errors: false,
        mobile_has_wakup_times_changed: false,
        mobile_has_medication_errors: false,
        current_week: null,
        medications: [],
        local_medications: [],

        data_in_bed: { HH: null, mm: null },
        data_asleep: { HH: null, mm: null },
        data_awaken: { HH: null, mm: null },
        data_out_bed: { HH: null, mm: null },

        sleep_type: { id: null, label: null },
        did_you_take_mediations: false,
        data: {
            date: null,
            sleep_type_id: null,
            medication_id: null,
            note: "",
            sleep_disturbances: [],
            medication_entries: [],
            naps: [],
        },

        previous_out_bed: {
            from_server: false,
            date: null,
            time: null,
        },

        serverDateFormat: "YYYY-MM-DD HH:mm:ss",
        recompute: 0,

        // responsive
        mobile_step: 1
    }),

    created() {
        this.$validator.extend('valid_sleep', {
            getMessage: field => this.$t('errors.validation.valid_sleep', { field: field }),
            validate: () => {
                this.recompute++
                return this.$nextTick().then(() => {
                    return { valid: this.validSleep }
                })
            }
        });

        this.$validator.extend('valid_awake', {
            getMessage: field => this.$t('errors.validation.valid_awake', { field: field }),
            validate: () => {
                this.recompute++
                return this.$nextTick().then(() => {
                    return { valid: this.validAwake }
                })
            }
        });

        this.current_week = this.$route.query.week

        this.$store.dispatch('general/sleepTypes')

        if (this.currentUser.user && this.currentUser.user.medical_info_id)
            this.$store.dispatch('user/readMedicalInfo', { user_id: this.currentUser.user.id, id: this.currentUser.user.medical_info_id }).then((medicalInfo) => {
                medicalInfo.medication.filter(m => m.medication_type_id === 1).forEach(med => {
                    this.medications.push({ value: med.id, label: med.name })
                    this.local_medications.push(Object.assign({}, { value: med.id, label: med.name }))
                })
            })

        if (this.$route.name === 'schedule-edit')
            this.$store.dispatch('schedule/readScheduleDay', { user_id: this.currentUser.user.id, day: this.$route.params.id, week: this.current_week }).then((day) => {
                this.data.id = day.id
                this.data.day = day.day
                this.data.date = day.date
                this.data.sleep_type_id = day.sleep_type_id
                this.sleep_type = this.sleepTypes.find((p) => p.id === day.sleep_type_id)

                this.data_in_bed = day.in_bed ? { HH: this.$moment(day.in_bed, this.serverDateFormat).format('HH'), mm: this.$moment(day.in_bed, this.serverDateFormat).format('mm') } : { HH: null, mm: null }
                this.data_asleep = day.asleep ? { HH: this.$moment(day.asleep).format('HH'), mm: this.$moment(day.asleep, this.serverDateFormat).format('mm') } : { HH: null, mm: null }
                this.data_awaken = day.awaken ? { HH: this.$moment(day.awaken).format('HH'), mm: this.$moment(day.awaken, this.serverDateFormat).format('mm') } : { HH: null, mm: null }
                this.data_out_bed = day.out_bed ? { HH: this.$moment(day.out_bed).format('HH'), mm: this.$moment(day.out_bed, this.serverDateFormat).format('mm') } : { HH: null, mm: null }

                this.data.note = day.note
                this.data.sleep_disturbances = day.sleep_disturbances
                this.data.naps = day.naps

                this.did_you_take_mediations = day.medication_entries.length > 0
                day.medication_entries.forEach((med) => {
                    let m = this.medications.find((m) => m.label === med.name)
                    if (m) m.amount = med.amount
                    else this.medications.push({ label: med.name, value: med.name, amount: med.amount })
                })

                this.update = true
                this.recompute++
            })
        else {
            this.update = false
            this.$set(this.data, 'date', this.$route.query.date)
        }
    },
    methods: {
        submit() {
            this.data.medication_entries = this.medications.filter((med) => med.amount).map((med) => { return { name: med.label, amount: med.amount } })
            this.$validator.validateAll().then(res => {
                if (res && this.validSleep && this.validAwake) {
                    this.loading = true
                    this.data.user_id = this.currentUser.user.id
                    this.data.week = this.current_week
                    this.server_error = null
                    this.$store.dispatch(`schedule/${!this.update ? 'createDay' : 'updateDay'}`, this.data).then(
                        day => {
                            this.loading = false
                            this.success = true
                            let updatedAt = this.scheduleOverview ? this.scheduleOverview.updated_at : null
                            setTimeout(() => this.fetchOverview(updatedAt), 1000);
                            if (!this.update && this.current_week <= 6)
                                this.$router.push({ name: 'tip-detail', params: { id: day.day } })
                            else
                                this.$router.push({ name: 'sleep-schedule' })
                        },
                        error => {
                            this.loading = false
                            this.success = false
                            if (Object.keys(error).filter(e => e.includes('sleep_disturbances')).length > 0) {
                                this.server_error = { sleep_disturbances: ["invalid_sleep_disturbances"] }
                            } else {
                                this.server_error = error
                            }
                        }
                    )
                }
            })
        },
        submitMedication() {
            this.$validator.validateAll('medication').then(res => {
                if (res) {
                    this.medications = [...this.local_medications.map(item => Object.assign({}, item))]
                    this.$modal.hide('add-medication');
                }
            })
        },
        getConicPercentage(a) {
            switch (a) {
                case '1/16':
                    return (1 / 16) * 100
                case '1/8':
                    return (1 / 8) * 100
                case '1/4':
                    return (1 / 4) * 100
                case '1/2':
                    return (1 / 2) * 100
                case '3/4':
                    return (3 / 4) * 100
                case '1':
                case '>1':
                    return 100
                default:
                    return 0
            }
        },
        next() {
            if (!this.mobile_step === 1 && this.mobile_step === 2) {
                this.mobile_step++;
                return;
            }

            if (this.mobile_step === 3) {
                this.validateMobileWakeup()

                if (!this.mobile_has_wakup_errors)
                    this.mobile_step++;

                return;
            }

            if (this.mobile_step === 4) {
                this.validateMobileWakeup()

                if (!this.mobile_has_wakup_errors)
                    this.mobile_step++;

                return;
            }

            if (this.mobile_step === 5) {
                this.$validator.validateAll('mobile_step_5').then(res => {
                    if (res) this.mobile_step++
                })

                return;
            }

            if (this.mobile_step === 6) {
                this.validateMobileMedication()

                if (!this.mobile_has_medication_errors)
                    this.mobile_step++;

                return;
            }

            let scope = this.mobile_step === 1 ? 'in_bed.*' : 'out_bed.*';

            this.$validator.validate(scope).then(res => {
                if (res) this.mobile_step++
            })
        },

        validateMobileWakeup() {
            let mobile_wu = this.$refs.mobileWakeup

            let time_ok = false
            if (mobile_wu.mobile_wu_time.HH === null && (mobile_wu.mobile_wu_time.mm === null || mobile_wu.mobile_wu_time.mm === ''))
                time_ok = true

            let duration_ok = false
            if (mobile_wu.mobile_wu_duration.HH === null && (mobile_wu.mobile_wu_duration.mm === null || mobile_wu.mobile_wu_duration.mm === ''))
                duration_ok = true

            if (time_ok && duration_ok) {
                this.mobile_has_wakup_errors = false
            }
            else {
                this.mobile_has_wakup_errors = true
            }
        },
        validateMobileMedication() {
            if (this.did_you_take_mediations) {
                this.mobile_has_medication_errors = this.medications.filter(m => !m.hasOwnProperty('amount') || !m.amount || !m.label).length > 0
            }
            else {
                this.mobile_has_medication_errors = false
            }
        },
        fetchOverview(updatedAt, times = 0) {
            let retryTime = times < 3 ? 1000 : 5000;
            this.$store.dispatch('schedule/readScheduleOverview', { user_id: this.currentUser.user.id, force: true }).then(overview => {
                if (updatedAt !== overview.updated_at || times >= 13) {
                    return;
                }
                setTimeout(() => this.fetchOverview(updatedAt, ++times), retryTime)
            })
        },
        handleDidYouTakeMedicationChange() {
            if (!this.did_you_take_mediations) {
                this.medications.forEach(med => {
                    delete med.amount
                })
                this.data.medication_entries = []
            }
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        sleepTypes() {
            return this.$store.getters['general/sleepTypes']
        },
        scheduleOverview() {
            return this.$store.getters['schedule/overview']
        },
        validSleep() {
            this.recompute

            if (!this.data.in_bed || !this.data.asleep) return true

            let in_bed = this.$moment(this.data.date + ' ' + this.data.in_bed, 'YYYY-MM-DD HH:mm')
            let asleep = this.$moment(this.data.date + ' ' + this.data.asleep, 'YYYY-MM-DD HH:mm')
            let awaken = null

            if (this.data.awaken) {
                awaken = this.$moment(this.data.date + ' ' + this.data.awaken, 'YYYY-MM-DD HH:mm')
            } else {
                awaken = this.$moment(this.data.date + '13:00', 'YYYY-MM-DD HH:mm')
            }

            if (in_bed.isAfter(awaken))
                in_bed.subtract(1, 'days')

            if (asleep.isAfter(awaken))
                asleep.subtract(1, 'days')

            return in_bed.isBefore(asleep) || in_bed.isSame(asleep) || (in_bed.isSame(asleep, 'day') && asleep.isAfter(in_bed))
        },
        validAwake() {
            this.recompute

            if (!this.data.awaken || !this.data.out_bed) {
                return true;
            }

            let awaken = this.$moment(this.data.date + ' ' + this.data.awaken, 'YYYY-MM-DD HH:mm')
            let out_bed = this.$moment(this.data.date + ' ' + this.data.out_bed, 'YYYY-MM-DD HH:mm')
            return awaken.isBefore(out_bed) || awaken.isSame(out_bed)
        },
        lockedStates() {
            if (!this.scheduleOverview) {
                return [];
            }
            return this.scheduleOverview.locked_states.reduce((results, week) => [...results, ...week.diary_entries], [])
        },
        locked() {
            let entry = this.lockedStates.find(entry => entry.date === this.data.date)
            if (!entry) {
                return true
            }
            return entry.locked
        },
        previousUnlockedEntry() {
            const previousState = this.lockedStates.find(ls => ls.locked === false && ls.id === null)
            return previousState;
        },
        previousUnlockedWeek() {
            if (!this.scheduleOverview) {
                return null;
            }
            return this.scheduleOverview.locked_states.find(ls => ls.diary_entries.includes(this.previousUnlockedEntry));
        }
    },

    watch: {
        'data.date': function (date) {
            let filterDate = this.$moment(date, "YYYY-MM-DD HH:mm:ss").add(-1, 'days').format('YYYY-MM-DD')
            this.$store.dispatch('schedule/indexDays', { user_id: this.currentUser.user.id, data: { date: filterDate } }).then(userDays => {
                if (!userDays.length) {
                    return
                }
                this.previous_out_bed.date = this.$moment(userDays[0].out_bed, this.serverDateFormat).format('YYYY-MM-DD')
                this.previous_out_bed.time = this.$moment(userDays[0].out_bed, this.serverDateFormat).format('HH:mm')
                this.previous_out_bed.from_server = true
            })
        },
        'data_in_bed': function (inBed) {
            if (this.previous_out_bed.from_server) {
                return
            }
            const fullDate = `${this.data.date} ${inBed.HH}:${inBed.mm}:00`
            this.previous_out_bed.date = this.$moment(fullDate, this.serverDateFormat).add(-12, 'hours').format('YYYY-MM-DD')
            this.previous_out_bed.time = this.$moment(fullDate, this.serverDateFormat).add(-12, 'hours').format('HH:mm')
        }
    }
}
</script>
